import React from "react";
import "../../../assets/css/Download.css";
import appStoreImg from "../../../assets/img/appstore.png";
import playStoreImg from "../../../assets/img/playstor.png";
import bannerMobile from "../../../assets/img/RentelPost.png";
import logoImg from "../../../assets/img/App-icon.png"
import img9 from "../../../assets/img/hand_click.png"
import { IoCloudDownload } from "react-icons/io5";
const Download = () => {
    const handleDownloadClick = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // iOS detection
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.location.href = "https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463";
            return;
        }

        // Android detection
        if (/android/i.test(userAgent)) {
            window.location.href =
                "https://play.google.com/store/apps/details?id=com.rent.el.in";
            return;
        }

        // Fallback (desktop or unknown)
        window.open(
            "https://play.google.com/store/apps/details?id=com.rent.el.in",
            "_blank"
        );
    };

    return (
        <section className="dl-section">

            {/* DESKTOP BANNER */}
            <div className="dl-banner">
                <div className="container">
                    <div className="dl-banner__overlay">
                        <div className="banner_hand_img">
                            <img className="banner_hand_" src={img9} />
                        </div>
                        <div className="dl-banner__right">
                            <div className="content_flex">
                                <h2 style={{ fontSize: "45px" }}>Why Buy?<br />Just Rent!</h2>
                                <p>Download on Android & iOS</p>
                                <div className="dl-banner__stores">
                                    <a href="https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463" target="_blank" className="store-badge" rel="noreferrer">
                                        <img src={appStoreImg} alt="App Store" />
                                    </a>
                                    <a href="https://play.google.com/store/apps/details?id=com.rent.el.in" target="_blank" className="store-badge" rel="noreferrer">
                                        <img src={playStoreImg} alt="Play Store" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* MOBILE BANNER */}
            <div className="dl-banner--mobile">
                <img src={bannerMobile} alt="Download App Banner" />

                {/* TOP FLOATING LOGO */}
                <div className="dl-banner__mobile-logo">
                    <img src={logoImg} alt="Rentel Logo" />
                </div>

                <div className="dl-banner__mobile-overlay">
                    <h2>Why Buy? Just Rent!</h2>
                    <p>Download on Android & iOS</p>

                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handleDownloadClick();
                        }}
                        className="dl-btn-red"
                    >
                        <span className="dl-btn-icon"><IoCloudDownload /></span>
                        <span className="dl-btn-text">Download</span>
                    </a>


                    <div style={{ display: "flex", gap: "20px" }}>
                        <a target="_blank" rel="noreferrer" className="store-badge" href="https://play.google.com/store/apps/details?id=com.rent.el.in">
                            <img src={playStoreImg} alt="Google Play" />
                        </a>

                        <a target="_blank" rel="noreferrer" className="store-badge" href="https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463" >
                            <img src={appStoreImg} alt="App Store" />
                        </a>
                    </div>
                </div>
            </div>



        </section>
    );
};

export default Download;
